import React, { ReactElement, useContext } from 'react';
import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { ClassificationSubTopicResponses } from 'screens/WidgetGenerator/utils/misc';

import { getAnswersLeadingSubTopicsData } from 'screens/WidgetGenerator/helpers/answersLeadingSubTopics';
import { useAsyncEffect } from 'customHooks/hooks';
import { logger } from 'utils/logger';
import { ReportBuilderComponentProps } from 'screens/WidgetGenerator/reportGeneratorComponents/components/WidgetWrappers/WidgetWrappers';

import { Bubble } from 'screens/WidgetGenerator/widgets/Bubble/Bubble';
import { SurveysReportGeneratorFilterKey } from '../../enums';

const DEFAULT_DATA: ClassificationSubTopicResponses[] = [
  {
    classificationSubTopicId: 0,
    classificationSubTopicValue: '',
    classificationTopicId: 0,
    classificationTopicValue: '',
    responses: 0,
  },
];

export const TopicsBubbleChartHOC = (props: ReportBuilderComponentProps): ReactElement => {
  const { client, cycles, selectedDateRange } = useContext(WidgetGeneratorContext);

  const fetchTopicsData = async () => {
    const fetchedTopicsData = await getAnswersLeadingSubTopicsData(client, cycles, selectedDateRange);
    return fetchedTopicsData;
  };
  const { params } = props;
  const { filters } = params;

  const {
    fetchedData: fetchedTopicsData,
    isLoading,
    error,
  } = useAsyncEffect(fetchTopicsData, [client, cycles, selectedDateRange]);

  if (error) {
    logger.error(error);
  }

  return (
    <LoaderMask isLoading={isLoading}>
      <Bubble
        widgetData={fetchedTopicsData ?? DEFAULT_DATA}
        scale={filters?.[SurveysReportGeneratorFilterKey.TOPICS_BUBBLE_CHART_SCALE_SELECT]}
        sentiment={filters?.[SurveysReportGeneratorFilterKey.TOPICS_BUBBLE_CHART_SENTIMENT_SELECT]}
      />
    </LoaderMask>
  );
};
